export type Coin = "gp" | "sp" | "cp";
export type Purse = Record<Coin, number>;

export const COINS: Coin[] = ["gp", "sp", "cp"];

// The old sheet's Converter: ten copper make a silver and ten silver a gold, and what is left stays.
export function consolidate({ gp, sp, cp }: Purse): Purse {
	const silver = sp + Math.trunc(cp / 10);
	return { gp: gp + Math.trunc(silver / 10), sp: silver % 10, cp: cp % 10 };
}

// What turns one purse into another, as the `coins` op's deltas; only the coins that change.
export function purseDeltas(from: Purse, to: Purse): Partial<Purse> {
	const deltas: Partial<Purse> = {};
	for (const coin of COINS) if (to[coin] !== from[coin]) deltas[coin] = to[coin] - from[coin];
	return deltas;
}
